import { render } from "./SwapBody.vue?vue&type=template&id=07d28d7f"
import script from "./SwapBody.vue?vue&type=script&lang=js"
export * from "./SwapBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__